import { render, staticRenderFns } from "./PageCogeneration.vue?vue&type=template&id=d725409e&scoped=true&"
import script from "./PageCogeneration.vue?vue&type=script&lang=js&"
export * from "./PageCogeneration.vue?vue&type=script&lang=js&"
import style0 from "./PageCogeneration.vue?vue&type=style&index=0&id=d725409e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d725409e",
  null
  
)

export default component.exports